import React from 'react';

export const GenericCard = ({ model, modelType, displayType, onClick, actions }) => {
    return (
        <div className={`generic-card ${displayType}`} onClick={onClick}>
            {displayType === 'list' ? (
                <>
                    <div className="content">
                        <h3>{model.name || model.title || `${modelType} #${model.id}`}</h3>
                        <p>{model.description || 'No description available'}</p>
                    </div>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            ) : (
                <>
                    <h3>{model.name || model.title || `${modelType} #${model.id}`}</h3>
                    <p>{model.description || 'No description available'}</p>
                    <div className="model-actions">
                        {actions}
                    </div>
                </>
            )}
        </div>
    );
};

export default GenericCard;
